import LoginCallBack from './LoginCallBack.vue'

export default LoginCallBack